import {makeObservable, observable} from "mobx";
import {isJson} from "../../../admin/spinup/utilities";
import {organizationStore} from "../../../../stores/StoreLoader";

class BlockObject implements IBlockObj {
    absoluteUrl: string;
    asyncLoaded: boolean;
    blockModel: OrganizationTypeOrganization;  //OrganizationTypeOrganization
    blockType: OrganizationType;
    cache: boolean;
    data: any;
    errorMessage?: string;
    filterBlockType: any;
    filterCategories: string;
    filterString: string;
    filterTags: string;
    fluxDeleted?: boolean;
    fluxLocked?: boolean;
    fluxMoved?: boolean;
    fluxParentDeleted?: boolean;
    fluxResized?: boolean;
    fluxUnlocked?: boolean;
    gridHeight: number;
    gridWidth: number;
    hasSubmitTitle: boolean;
    htmlOutput?: string;
    id: string;
    isBlockInEmail: boolean;
    isDepartment: boolean;
    isModalTrigger: boolean;
    isSearchResult: boolean;
    key: AnyBlockObj[];
    loadAsync: boolean;
    modalTitle: string;
    name: string;
    outputHtml?: string;
    positionLocked: boolean;
    posX: number;
    posY: number;
    renderHtml: boolean;
    renderWrapper: boolean;
    showErrors: boolean;
    sizeX: number;
    sizeY: number;
    title?: string;
    useAbsoluteUrls: boolean;
    footerData: {
        cssColorClass: string,
        grandParentText: string,
        parentText: string,
        parentType: string,
        url: string,
    };
    contentSources: any;

    constructor(blockType: OrganizationType, initialProps?: AnyBlockObj | IPersonBlock | undefined) {
        this.blockType = blockType;
        makeObservable(this, {
            asyncLoaded: observable,
            blockType: observable,
            contentSources: observable,
            errorMessage: observable,
            fluxDeleted: observable,
            fluxLocked: observable,
            fluxMoved: observable,
            fluxParentDeleted: observable,
            fluxResized: observable,
            fluxUnlocked: observable,
            gridHeight: observable,
            gridWidth: observable,
            id: observable,
            positionLocked: observable,
            posX: observable,
            posY: observable,
            sizeX: observable,
            sizeY: observable,
            title: observable,
        });
    }

    setAttributes(attrs): void {
        for (const key in attrs) {
            if (key === 'blockModel' && isJson(attrs[key]?.json_data)) {
                // convert this string to JSON.
                attrs[key].json_data = JSON.parse(attrs[key].json_data);
            }
            this[key] = attrs[key];
        }
    }

    async getContentSources(blockId) {
        return await organizationStore.fetchClient('organizations', 'organizations_content_sources_list', ({
            organization_pk: blockId,
        }));
    }

    async deleteContentSources(sourcesToDelete, blockId) {
        const sourceIdArray = sourcesToDelete.map(s => s.id);
        await organizationStore.fetchClient("organizations", "organizations_content_sources_bulk_destroy", {
            organization_pk: blockId,
            data: sourceIdArray,
        });
    }

    async updateContentSources(blockId: string, initialContentSources: any[] = [], newContentSources: any[]) {
        // add it if the lang isn't in initial or if it is and the urls dont match.
        const sourcesToAdd = newContentSources.filter(source =>
            source.language && (!initialContentSources.find((iSource) => iSource.language === source.language)
                || initialContentSources.find((iSource) => iSource.language === source.language && iSource.source_url !== source.source_url))
        );
        // we can only update it if the url and language match.
        const sourcesToUpdate = newContentSources
            .filter(source => !sourcesToAdd.includes(source))
            .filter(source => initialContentSources.find((iSource) =>
                iSource.source_url === source.source_url && iSource.language === source.language)
            );
        // delete the ones we aren't updating.
        const sourcesToDelete = initialContentSources.filter(iSource =>
            !sourcesToUpdate.find((uSource) => uSource.language === iSource.language)
        )

        if (sourcesToDelete.length > 0) await this.deleteContentSources(sourcesToDelete, blockId);
        if (sourcesToAdd.length > 0) {
            for (const source of sourcesToAdd) {
                source.id = undefined;
                await organizationStore.fetchClient('organizations', 'organizations_content_sources_create', {
                    organization_pk: blockId,
                    data: source,
                    language: source.language,
                })
            }
        }
        for (const source of sourcesToUpdate) {
            await organizationStore.fetchClient("organizations", "organizations_content_sources_partial_update", {
                organization_pk: blockId,
                id: source.id,
                data: source,
            })
        }
    }

    contentSourceToSettings (contentSource: any) {}
    contentItemToSettings (contentItem: any) {}
    settingsToContentSource (blockObj, settingsObject: IBlockSettingsObject, language: string) {}
    settingsObjectToSettings (settingsObj: IBlockSettingsObject) {}
}

export default BlockObject;
